import { set } from 'es-toolkit/compat';
import { type ConfigObject, DebugLevel } from '../../_configs/types';
import { type HptSessionStorageSettings, LOCAL_STORAGE_SETTINGS, getSessionStorage } from '../../hooks/use-storage';
import type { Modules } from '../../modules/_definition/types';
import checkUndefinedNullOrEmpty from '../tools/checkUndefinedNullOrEmpty';
import checkUndefinedOrNull from '../tools/checkUndefinedOrNull';
import merge from '../tools/merge';

const configFields = {
    'data-general-debug': 'general.debug',
    'data-general-accept-maps-external': 'general.acceptMapsExternal',
    'data-general-islandingpage': 'general.isLandingpage',
    'data-general-mockup': 'general.mockup',
    'data-general-searchpath': 'general.searchPath',
    'data-general-usecanonicallinks': 'general.useCanonicalLinks',
    'data-contact-linkdisclaimer': 'contact.linkDisclaimer',
    'data-modulesettings-defaultfilter': '[module].defaultFilter',
    'data-modulesettings-defaultfilter-id': '[module].defaultFilterId',
    'data-modulesettings-onefilterperrow': '[module].oneFilterPerRow',
    'data-style-disable-slider-shadow': 'style.disableSliderShadow',
    'data-style-font-family-title': [
        'style.muiTypography.h1.fontFamily',
        'style.muiTypography.h2.fontFamily',
        'style.muiTypography.h3.fontFamily',
        'style.muiTypography.h4.fontFamily',
        'style.muiTypography.h5.fontFamily',
        'style.muiTypography.h6.fontFamily',
    ],
    'data-style-font-family-body': 'style.fontFamily',
    'data-style-font-family-button': 'style.muiTypography.button.fontFamily',
    'data-style-primary-color': 'style.primaryColor',
    'data-style-secondary-color': 'style.secondaryColor',
};

function handleDeprecatedFields(s: ConfigObject) {
    const deprecatedFields = [];
    const newS: ConfigObject = Object.assign({}, s);
    deprecatedFields.map(function () {
        //
    });
    return newS;
}

export default function getAdditionalConfig(settings: ConfigObject, module: Modules, rootContainer: HTMLDivElement, debug: DebugLevel): ConfigObject {
    const additionalConfig: Partial<ConfigObject> = {};

    if (debug === DebugLevel.CONFIG || debug >= DebugLevel.INFO) {
        console.log(`${module} - getAdditionalConfig - rootContainer`, rootContainer);
    }
    if (!checkUndefinedOrNull(rootContainer)) {
        Object.keys(configFields).map(function (field) {
            const configFieldOfContainer = rootContainer.getAttribute(field);
            const valueToUse =
                configFieldOfContainer === 'true'
                    ? true
                    : configFieldOfContainer === 'false'
                      ? false
                      : parseFloat(configFieldOfContainer)
                        ? parseFloat(configFieldOfContainer)
                        : configFieldOfContainer;
            if (debug === DebugLevel.CONFIG || debug >= DebugLevel.INFO) {
                console.log(`${module} - getAdditionalConfig - field`, field);
                console.log(`${module} - getAdditionalConfig - configFieldOfContainer`, configFieldOfContainer);
                console.log(`${module} - getAdditionalConfig - valueToUse`, valueToUse);
            }
            if (!checkUndefinedNullOrEmpty(valueToUse)) {
                if (Array.isArray(configFields[field])) {
                    for (let i = 0; i < configFields[field].length; i++) {
                        set(additionalConfig, configFields[field][i].replace('[module]', module), valueToUse);
                    }
                } else {
                    set(additionalConfig, configFields[field].replace('[module]', module), valueToUse);
                }
            }
        });
    }

    const heading = document?.querySelector('h1');

    const sessionStorage: HptSessionStorageSettings = getSessionStorage<HptSessionStorageSettings>(LOCAL_STORAGE_SETTINGS);
    const newSettings = merge(settings, additionalConfig, { general: { debug: sessionStorage?.debug }, fahrzeugsuche: { originalH1: heading?.innerText } });
    if (debug === DebugLevel.CONFIG || debug >= DebugLevel.INFO) {
        console.log(`${module} - getAdditionalConfig - additionalConfig`, additionalConfig);
        console.log(`${module} - getAdditionalConfig - heading`, heading);
        console.log(`${module} - getAdditionalConfig - newSettings`, newSettings);
    }
    return handleDeprecatedFields(newSettings);
}
